@if (isMultiple()) {
  <smw-checkbox [checked]="isChecked()" />
}
<ng-content>{{ option().label }}</ng-content>
